import React from 'react';

import { Button } from '@/components';
import { useTranslation } from '@/hooks';

type GoBackButtonProps = {
  goBack?: () => void;
};
const GoBackButton: React.FC<GoBackButtonProps> = ({ goBack }) => {
  const { t } = useTranslation('pages.signUp.form');

  return (
    <Button variant="link" w="full" onClick={goBack} h="44px">
      {t('back')}
    </Button>
  );
};

export default GoBackButton;
